import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { FiHeart, FiPlus } from "react-icons/fi";
import { CartContext } from "./CartContext";
import { formatMoney } from "../utils/commerce";

function ProductCard({ product, priority = false }) {
  const { addToCart } = useContext(CartContext);
  const [added, setAdded] = useState(false);

  const quickAdd = (event) => {
    event.preventDefault();
    addToCart(product.id, 1, product.size[0], product.colors[0]);
    setAdded(true);
    window.setTimeout(() => setAdded(false), 1400);
  };

  return (
    <article className="product-card">
      <div className="product-card__media">
        <Link to={`/products/${product.id}`} className="product-card__image-link" aria-label={`View ${product.name}`}>
          <img className="product-card__primary" src={product.image} alt={product.name} loading={priority ? "eager" : "lazy"} />
          {product.images[1] && <img className="product-card__secondary" src={product.images[1]} alt="" loading="lazy" />}
          {product.badge && <span className={`product-card__badge ${product.badge === "FINAL SALE" ? "is-sale" : ""}`}>{product.badge}</span>}
        </Link>
        <button className="product-card__wish" type="button" aria-label={`Save ${product.name}`}>
          <FiHeart aria-hidden="true" />
        </button>
        <button className="product-card__quick" type="button" onClick={quickAdd}>
          <FiPlus aria-hidden="true" /> {added ? "Added" : "Quick add"}
        </button>
      </div>
      <div className="product-card__content">
        <Link to={`/products/${product.id}`} className="product-card__name">{product.name}</Link>
        <div className="product-card__meta">
          <span>{product.colors.length} {product.colors.length === 1 ? "colour" : "colours"}</span>
          <span className="product-card__price">
            {product.compareAtPrice && <s>{formatMoney(product.compareAtPrice)}</s>}
            {formatMoney(product.price)}
          </span>
        </div>
      </div>
    </article>
  );
}

export default ProductCard;
